import * as React from 'react';
import { LocationLanguageContextType, SectionFieldContainerProps } from 'typings';
import { Button, Typography } from '@material-ui/core';
import InsertLinkOutlinedIcon from '@material-ui/icons/InsertLinkOutlined';
import { useStaticQuery, graphql } from 'gatsby';
import useLinkFormStyles from '../../styles/LinkForm';
import FieldTitle from './FieldTitle';
import { LocationLanguageContext } from '../../contexts/LocationLanguageContext';
import { Languages } from '../../utils/getAllSupportedLanguages';

const LinkFormsWeb: React.FC<SectionFieldContainerProps> = (linkFormsProps) => {
  const classes = useLinkFormStyles();
  const { sectionFieldDetails } = linkFormsProps;
  const { name, isMandatory } = sectionFieldDetails;
  const data = useStaticQuery(
    graphql`
      query LinkFormWebQuery {
        allStrapiTemplatePage {
          nodes {
            LinkFormLabel
            locale
          }
        }
      }
    `
  );

  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language: string = locationLanguage?.language ?? Languages.English;
  const templatePage = data.allStrapiTemplatePage.nodes.find((x: any) => x.locale === language);

  return (
    <>
      <FieldTitle name={name} isMandatory={isMandatory} />
      <Button variant='outlined' className={classes.linkForm} startIcon={<InsertLinkOutlinedIcon color='primary' />}>
        <Typography variant='caption' className={classes.webText}>
          {templatePage.LinkFormLabel}
        </Typography>
      </Button>
    </>
  );
};

export default LinkFormsWeb;
